<template>
    <div>
        <div class="grid-fitted grid-unstackable">
            <div class="grid-item">
                <r-button
                    @click="resendEmail"
                    :disabled="isResending"
                    size="small"
                    class="inline-s">
                    Resend Email
                </r-button>
            </div>
            <div class="grid-item text-right" v-if="model.hasAttachments">
                <v-icon-button
                    type="basic"
                    size="small"
                    tooltip="Download Invoice"
                    :title="`download ${attachment.resourceType}`"
                    v-for="(attachment, index) in model.attachments"
                    :disabled="isDownloading"
                    :key="`index-${attachment.resourceId}-${index}`"
                    class="inline-s"
                    @click="() => downloadAttachment(index)">
                    <v-icon icon="download"/>
                </v-icon-button>
            </div>
        </div>
    </div>
</template>
<script>
    import EmailMessageModel from '@/common/models/email-message-model';
    import Media from '@/common/files/media';
    import {vIcon, vIconButton} from '@/components/form';

    export default {
        name: 'message-attachments',
        components: {
            vIcon,
            vIconButton,
        },
        props: {
            entityId: {
                type: String,
                required: true,
            },
            model: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isDownloading: false,
                isResending: false,
            };
        },
        methods: {
            async resendEmail() {
                try {
                    this.isResending = true;
                    const data = this.model.getPayload();
                    await this.$api(({emailMessages}) => emailMessages.create({
                        data: {
                            ...data,
                            status: EmailMessageModel.Statuses.outbox,
                        },
                    }));
                    this.isResending = false;
                    this.$toast.positive('Email has been sent.');
                } catch (e) {
                    this.isResending = false;
                    this.$toast.negative('Unable to send the email. Please try again later or contact support.');
                }
            },
            async downloadAttachment(index) {
                const {resourceType, resourceId} = this.model.attachments[index];

                let data;
                const fileName = `${resourceType}-${resourceId}.pdf`;
                const mimeType = 'application/pdf';
                this.isDownloading = true;

                switch (resourceType) {
                    case 'invoice': {
                                        const invoice = await this.$api(
                                            ({invoices}) => invoices.downloadPDF({id: resourceId}),
                                        );
                                        // eslint-disable-next-line
                    data = invoice.data;
                                    }
                                    break;
                    default:
                        throw new Error(`Implement the download file ${resourceType}.`);
                }

                try {
                    const media = new Media({
                        mimeType,
                        data,
                        fileName,
                    });
                    media.triggerDownload();
                } catch (e) {
                    this.$toast.negative(`Unable to download the ${resourceType}. Please try again later or contact support.`);
                }
                this.isDownloading = false;
            },
        },
    };
</script>
